/* ========================================
   NINJON — Texture Float
   Injects a fixed background texture div and drives
   a gentle autonomous drift using sine/cosine oscillation.
   No mouse or scroll dependency — just a slow, ambient float.
   ======================================== */

(function () {

  /* ── Tuning ── */
  var DRIFT_X     = 18;    /* px range of horizontal drift (peak to peak = 2×) */
  var DRIFT_Y     = 12;    /* px range of vertical drift */
  var PERIOD_X    = 22000; /* ms for one full X cycle — slower = dreamier */
  var PERIOD_Y    = 31000; /* ms for one full Y cycle — different period = organic feel */

  /* ── Inject element ── */
  var el  = document.createElement('div');
  el.id   = 'nin-texture';
  document.body.insertBefore(el, document.body.firstChild);

  /* ── Animation loop ── */
  function tick(ts) {
    var x = Math.sin((ts / PERIOD_X) * Math.PI * 2) * DRIFT_X;
    var y = Math.cos((ts / PERIOD_Y) * Math.PI * 2) * DRIFT_Y;
    el.style.transform = 'translate(' + x.toFixed(2) + 'px, ' + y.toFixed(2) + 'px)';
    requestAnimationFrame(tick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { requestAnimationFrame(tick); });
  } else {
    requestAnimationFrame(tick);
  }

})();